module.exports = "https://beta.voredev.ru/assets/index/reply-green-1f8782cf5a9da8295d6c93c6e9aa8981.svg";